(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7942],{

/***/ 7234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(1720));
var makeUrls_1 = __importDefault(__webpack_require__(9646));
var useAutoFocus = function () {
    var elementRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var previous = document.activeElement;
        var element = elementRef.current;
        if (element) {
            element.focus();
        }
        if (previous instanceof HTMLElement) {
            return function () { return previous.focus(); };
        }
        return undefined;
    }, []);
    return elementRef;
};
var useOpenState = function (initialOpen) {
    var _a = react_1.useState(initialOpen), open = _a[0], setOpen = _a[1];
    var onToggle = function () { return setOpen(function (current) { return !current; }); };
    react_1.useEffect(function () {
        if (open) {
            var onClose_1 = function () { return setOpen(false); };
            document.addEventListener("click", onClose_1);
            return function () { return document.removeEventListener("click", onClose_1); };
        }
        return undefined;
    }, [open, setOpen]);
    return [open, onToggle];
};
var Calendar = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.filename, filename = _b === void 0 ? false : _b, href = _a.href;
    return (react_1.default.createElement("a", { ref: ref, download: filename, href: href, target: "_blank", rel: "noopener noreferrer" }, children));
});
var Dropdown = function (_a) {
    var filename = _a.filename, onToggle = _a.onToggle, urls = _a.urls;
    var ref = useAutoFocus();
    var onKeyDown = function (event) {
        if (event.key === "Escape") {
            onToggle();
        }
    };
    return (react_1.default.createElement("div", { className: "chq-atc--dropdown", onKeyDown: onKeyDown, role: "presentation" },
        react_1.default.createElement(Calendar, { href: urls.ics, filename: filename, ref: ref }, "Apple Calendar"),
        react_1.default.createElement(Calendar, { href: urls.google }, "Google"),
        react_1.default.createElement(Calendar, { href: urls.ics, filename: filename }, "Outlook"),
        react_1.default.createElement(Calendar, { href: urls.outlook }, "Outlook Web App"),
        react_1.default.createElement(Calendar, { href: urls.yahoo }, "Yahoo")));
};
var AddToCalendar = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Add to My Calendar" : _b, event = _a.event, _c = _a.filename, filename = _c === void 0 ? "download" : _c, _d = _a.open, initialOpen = _d === void 0 ? false : _d;
    var _e = useOpenState(initialOpen), open = _e[0], onToggle = _e[1];
    var urls = react_1.useMemo(function () { return makeUrls_1.default(event); }, [event]);
    return (react_1.default.createElement("div", { className: "chq-atc" },
        event && (react_1.default.createElement("button", { type: "button", className: "chq-atc--button", onClick: onToggle },
            react_1.default.createElement("svg", { width: "20px", height: "20px", viewBox: "0 0 1024 1024" },
                react_1.default.createElement("path", { d: "M704 192v-64h-32v64h-320v-64h-32v64h-192v704h768v-704h-192z M864 864h-704v-480h704v480z M864 352h-704v-128h160v64h32v-64h320v64h32v-64h160v128z" })),
            " ",
            children)),
        open && react_1.default.createElement(Dropdown, { filename: filename, onToggle: onToggle, urls: urls })));
};
exports["default"] = AddToCalendar;


/***/ }),

/***/ 9646:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var makeDuration = function (event) {
    var minutes = Math.floor((+new Date(event.endsAt) - +new Date(event.startsAt)) / 60 / 1000);
    return "" + ("0" + Math.floor(minutes / 60)).slice(-2) + ("0" + minutes % 60).slice(-2);
};
var makeTime = function (time) { return new Date(time).toISOString().replace(/[-:]|\.\d{3}/g, ""); };
var makeUrl = function (base, query) { return Object.keys(query).reduce(function (accum, key, index) {
    var value = query[key];
    if (value !== null) {
        return "" + accum + (index === 0 ? "?" : "&") + key + "=" + encodeURIComponent(value);
    }
    return accum;
}, base); };
var makeGoogleCalendarUrl = function (event) { return makeUrl("https://calendar.google.com/calendar/render", {
    action: "TEMPLATE",
    dates: makeTime(event.startsAt) + "/" + makeTime(event.endsAt),
    location: event.location,
    text: event.name,
    details: event.details
}); };
var makeOutlookCalendarUrl = function (event) { return makeUrl("https://outlook.live.com/owa", {
    rru: "addevent",
    startdt: event.startsAt,
    enddt: event.endsAt,
    subject: event.name,
    location: event.location,
    body: event.details,
    allday: false,
    uid: new Date().getTime().toString(),
    path: "/calendar/view/Month"
}); };
var makeYahooCalendarUrl = function (event) { return makeUrl("https://calendar.yahoo.com", {
    v: 60,
    view: "d",
    type: 20,
    title: event.name,
    st: makeTime(event.startsAt),
    dur: makeDuration(event),
    desc: event.details,
    in_loc: event.location
}); };
var makeICSCalendarUrl = function (event) {
    var components = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT"
    ];
    // In case of SSR, document won't be defined
    if (typeof document !== "undefined") {
        components.push("URL:" + document.URL);
    }
    components.push("DTSTART:" + makeTime(event.startsAt), "DTEND:" + makeTime(event.endsAt), "SUMMARY:" + event.name, "DESCRIPTION:" + event.details, "LOCATION:" + event.location, "END:VEVENT", "END:VCALENDAR");
    return encodeURI("data:text/calendar;charset=utf8," + components.join("\n"));
};
var makeUrls = function (event) { return ({
    google: makeGoogleCalendarUrl(event),
    outlook: makeOutlookCalendarUrl(event),
    yahoo: makeYahooCalendarUrl(event),
    ics: makeICSCalendarUrl(event)
}); };
exports["default"] = makeUrls;


/***/ }),

/***/ 7926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formatDistance; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(4314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(3882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/compareAsc/index.js


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfDay/index.js


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isLastDayOfMonth/index.js




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth((0,toDate/* default */.Z)(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,toDate/* default */.Z)(dateLeft).getTime() - (0,toDate/* default */.Z)(dateRight).getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(6559);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/cloneObject/index.js

function cloneObject(object) {
  return assign_assign({}, object);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(4262);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistance/index.js










var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = assign_assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = (0,toDate/* default */.Z)(dirtyBaseDate);
    dateRight = (0,toDate/* default */.Z)(dirtyDate);
  } else {
    dateLeft = (0,toDate/* default */.Z)(dirtyDate);
    dateRight = (0,toDate/* default */.Z)(dirtyBaseDate);
  }

  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = ((0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateRight) - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months; // 0 up to 2 mins

  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    } // 2 mins up to 0.75 hrs

  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }

  months = differenceInMonths(dateRight, dateLeft); // 2 months up to 12 months

  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12); // N years up to 1 years 3 months

    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

/***/ }),

/***/ 7453:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]",
      function () {
        return __webpack_require__(4800);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ SocialShare; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2916);
/* harmony import */ var _react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1362);
/* harmony import */ var _react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7951);
/* harmony import */ var _react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6625);
/* harmony import */ var _react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7443);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4850);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8420);







function SocialShare(param) {
    var siteName = param.siteName, shareTitle = param.shareTitle, shareSummary = param.shareSummary, shareImage = param.shareImage, tagList = param.tagList, twitterUsername = param.twitterUsername, url = param.url, updatedAt = param.updatedAt;
    //  Source: https://cloudcannon.com/blog/lightweight-social-share-buttons/
    //  Encode URL params: https://stackoverflow.com/questions/8135132/how-to-encode-url-parameters
    //   site name (source)
    // - siteName
    // title of the post
    // - shareTitle
    // summary / description of the post
    // - shareSummary
    // (media) Image to share
    // - shareImage
    // (tags) is a comma separated list of tags
    // - tagList
    // Twitter username of the author or site (without “@”)
    // - twitterUsername
    // console.log({updatedAt})
    var handleFacebookShare = function() {
        var winHeight = 436;
        var winWidth = 626;
        var winTop = screen.height / 2 - winHeight / 2;
        var winLeft = screen.width / 2 - winWidth / 2;
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + url, "sharer", "top=" + winTop + ",left=" + winLeft + ",toolbar=0,status=0,width=" + winWidth + ",height=" + winHeight);
    };
    var TwitterShareURL = twitterUsername ? "https://twitter.com/intent/tweet?url=".concat(url, "&text=").concat(shareTitle, "&via=").concat(twitterUsername) : "https://twitter.com/intent/tweet?url=".concat(url, "&text=").concat(shareTitle);
    //  Twitter - https://twitter.com/intent/tweet?url={}&text={}&via={}`
    var handleTwitterShare = function() {
        window.open("".concat(TwitterShareURL));
    };
    // LinkedIn - https://www.linkedin.com/shareArticle?mini=true&url={}&title={}&summary={}&source={}
    var handleLinkedInShare = function() {
        window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + shareTitle + "&source=" + siteName + "&summary=" + shareSummary);
    };
    //  PinTrest - https://www.pinterest.com/pin/create/button/?url={}&media={}&description={}
    var handlePintrestShare = function() {
        window.open("https://pinterest.com/pin/create/button/?url=" + url + "&media=" + shareImage + "&description=" + shareSummary);
    };
    // Reddit - https://reddit.com/submit?url={}&title={}&resubmit=true
    var handleRedditShare = function() {
        window.open("https://reddit.com/submit?url=" + url + "&title=" + shareTitle + "&resubmit=true");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("footer", {
        className: "flex flex-wrap items-center pb-4 mb-8 border-b-2 lg:mb-8 md:flex-nowrap md:pb-0 border-b-gray-100 md:border-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "items-center flex-none text-xs font-bold tracking-wider text-gray-500 uppercase",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        children: "Last updated"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "mx-1 text-gray-400",
                        "aria-hidden": "true",
                        children: "•"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("time", {
                            dateTime: updatedAt,
                            children: (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(updatedAt), "MMM do, yyyy")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "flex items-center flex-auto w-full mx-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                    className: "w-full h-[2px] bg-gray-100 hidden md:block"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "flex flex-wrap items-center flex-none my-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "items-center flex-none mr-1 text-xs font-bold tracking-wider text-gray-500 uppercase",
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "text-xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            type: "button",
                            onClick: function() {
                                return handleFacebookShare();
                            },
                            className: "block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-600",
                            "aria-label": "Share on Facebook",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_3__/* .FaFacebookF */ .t, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "text-xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            type: "button",
                            onClick: function() {
                                return handleTwitterShare();
                            },
                            className: "block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-300",
                            "aria-label": "Share on Twitter",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .f, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "text-xl ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            type: "button",
                            onClick: function() {
                                return handleLinkedInShare();
                            },
                            className: "block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-blue-500",
                            "aria-label": "Share on LinkedIn",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__/* .FaLinkedinIn */ .B, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "text-xl ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            type: "button",
                            onClick: function() {
                                return handlePintrestShare();
                            },
                            className: "block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-pink-600",
                            "aria-label": "Share on Pinterest",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_6__/* .FaPinterestP */ .c, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                        className: "text-xl ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            type: "button",
                            onClick: function() {
                                return handleRedditShare();
                            },
                            className: "block py-4 pr-1 mr-3 text-gray-400 transition-all hover:text-red-500",
                            "aria-label": "Share on Reddit",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_7__/* .FaRedditAlien */ .V, {})
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);

function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "flex items-start justify-start mx-6 my-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "w-12 h-12 ease-linear border-4 border-t-4 border-gray-200 rounded-full loader"
        })
    });
}


/***/ }),

/***/ 4800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(2918);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./lib/sanity.js
var sanity = __webpack_require__(8107);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExclamationIcon.js
var ExclamationIcon = __webpack_require__(3772);
// EXTERNAL MODULE: ./components/layout/header/index.js + 3 modules
var header = __webpack_require__(7821);
// EXTERNAL MODULE: ./components/layout/content-components/index.tsx + 31 modules
var content_components = __webpack_require__(3301);
// EXTERNAL MODULE: ./components/layout/footer/index.js + 1 modules
var footer = __webpack_require__(8038);
// EXTERNAL MODULE: ./components/shared/preview-alert/index.js
var preview_alert = __webpack_require__(1698);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(3854);
;// CONCATENATED MODULE: ./components/content/event/virtual-link/index.tsx



var EventVirtualLink = function(param) {
    var links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                className: "block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiLink */.WRS, {
                        className: "inline-block"
                    }),
                    " Attend Online"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "flex flex-col space-y-2",
                children: links === null || links === void 0 ? void 0 : links.map(function(link) {
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                            url: link === null || link === void 0 ? void 0 : link.url,
                            classes: "hover:underline",
                            children: link === null || link === void 0 ? void 0 : link.title
                        })
                    }, link._key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/content/event/access-link/index.tsx



var EventAccessLink = function(param) {
    var links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                className: "block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiTicket */.pDI, {
                        className: "inline-block"
                    }),
                    " Purchase Tickets"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "flex flex-col space-y-2",
                children: links === null || links === void 0 ? void 0 : links.map(function(link) {
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                            url: link === null || link === void 0 ? void 0 : link.url,
                            classes: "inline-flex items-center justify-center border border-transparent rounded-md shadow-sm bg-brand-2-700 text-white hover:bg-brand-2-500 transition text-center font-medium text-sm lg:text-base px-2.5 py-1.5",
                            children: link === null || link === void 0 ? void 0 : link.title
                        })
                    }, link._key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/content/event/access-ticket/index.tsx



function EventAccessTicket(param) {
    var products = param.products, image = param.image, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                className: "block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiTicket */.pDI, {
                        className: "inline-block"
                    }),
                    " Purchase Tickets"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "flex flex-col space-y-4",
                children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                            type: "submit",
                            className: "inline-flex items-center px-2.5 py-1.5 bg-indigo-600 border border-transparent rounded-md shadow-sm text-xs font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 snipcart-add-item",
                            "data-item-name": product === null || product === void 0 ? void 0 : product.title,
                            "data-item-id": product === null || product === void 0 ? void 0 : product.slug,
                            "data-item-price": product === null || product === void 0 ? void 0 : product.price,
                            "data-item-url": url,
                            "data-item-description": product === null || product === void 0 ? void 0 : product.description,
                            "data-item-image": (0,sanity/* urlFor */.uH)(product === null || product === void 0 ? void 0 : (ref = product.mainImage) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.asset).auto("format").width(100).height(100).url() || image,
                            "data-item-taxable": (product === null || product === void 0 ? void 0 : product.taxable) === true ? "true" : "false",
                            "data-item-has-taxes-included": (product === null || product === void 0 ? void 0 : product.taxIncluded) === true ? "true" : "false",
                            "data-item-shippable": (product === null || product === void 0 ? void 0 : product.shipping) === true ? "true" : "false",
                            "data-item-weight": (product === null || product === void 0 ? void 0 : product.shipping) && (product === null || product === void 0 ? void 0 : product.type) === "physical" && (product === null || product === void 0 ? void 0 : product.weight) && (product === null || product === void 0 ? void 0 : product.weight),
                            "data-item-length": (product === null || product === void 0 ? void 0 : product.shipping) && (product === null || product === void 0 ? void 0 : product.type) === "physical" && (product === null || product === void 0 ? void 0 : product.length) && (product === null || product === void 0 ? void 0 : product.length),
                            "data-item-height": (product === null || product === void 0 ? void 0 : product.shipping) && (product === null || product === void 0 ? void 0 : product.type) === "physical" && (product === null || product === void 0 ? void 0 : product.height) && (product === null || product === void 0 ? void 0 : product.height),
                            "data-item-width": (product === null || product === void 0 ? void 0 : product.shipping) && (product === null || product === void 0 ? void 0 : product.type) === "physical" && (product === null || product === void 0 ? void 0 : product.width) && (product === null || product === void 0 ? void 0 : product.width),
                            "data-item-max-quantity": product === null || product === void 0 ? void 0 : product.maxQuantity,
                            "data-item-min-quantity": product === null || product === void 0 ? void 0 : product.minQuantity,
                            children: [
                                "Buy ",
                                product === null || product === void 0 ? void 0 : product.title,
                                " $",
                                product === null || product === void 0 ? void 0 : product.price
                            ]
                        })
                    }, product._key);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistance/index.js + 11 modules
var formatDistance = __webpack_require__(7926);
;// CONCATENATED MODULE: ./components/content/event/date-time/index.tsx



function EventDateTime(param) {
    var dateTime = param.dateTime, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                className: "block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiCalendar */.IAP, {
                        className: "inline-block"
                    }),
                    " ",
                    title
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                className: "text-base text-gray-700",
                dateTime: dateTime,
                children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(dateTime), "EEEE MMMM do, yyyy p")
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                className: "mt-1 text-sm text-gray-500",
                children: (0,formatDistance/* default */.Z)((0,parseISO/* default */.Z)(dateTime), new Date(), {
                    addSuffix: true
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
;// CONCATENATED MODULE: ./components/content/event/location/index.tsx




function EventLocation(param) {
    var location = param.location;
    var ref, ref1, ref2, ref3;
    // console.log({location})
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                className: "block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiLocationMarker */.XAC, {
                        className: "inline-block"
                    }),
                    " Location "
                ]
            }),
            (location === null || location === void 0 ? void 0 : location.organization) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                className: "mb-1 text-base font-semibold text-gray-600",
                children: location === null || location === void 0 ? void 0 : location.organization
            }),
            (location === null || location === void 0 ? void 0 : location.address) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                className: "mb-1 text-base text-gray-600",
                children: location === null || location === void 0 ? void 0 : location.address
            }),
            ((location === null || location === void 0 ? void 0 : location.city) || (location === null || location === void 0 ? void 0 : location.state) || (location === null || location === void 0 ? void 0 : location.zip)) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                className: "mb-1 text-base text-gray-600",
                children: [
                    location === null || location === void 0 ? void 0 : location.city,
                    " ",
                    location === null || location === void 0 ? void 0 : location.state,
                    " ",
                    location === null || location === void 0 ? void 0 : location.zip
                ]
            }),
            (location === null || location === void 0 ? void 0 : (ref = location.geoLocation) === null || ref === void 0 ? void 0 : ref.lat) && (location === null || location === void 0 ? void 0 : (ref1 = location.geoLocation) === null || ref1 === void 0 ? void 0 : ref1.lng) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                className: "flex items-center mb-2 space-x-2 text-base text-gray-600",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(fa_index_esm/* FaMapMarkedAlt */.rB_, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                        url: "https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=".concat(location === null || location === void 0 ? void 0 : (ref2 = location.geoLocation) === null || ref2 === void 0 ? void 0 : ref2.lat, ",").concat(location === null || location === void 0 ? void 0 : (ref3 = location.geoLocation) === null || ref3 === void 0 ? void 0 : ref3.lng),
                        classes: "hover:underline",
                        children: "Map and Directions"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/content/social-share/index.tsx
var social_share = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/@culturehq/add-to-calendar/dist/AddToCalendar.js
var AddToCalendar = __webpack_require__(7234);
var AddToCalendar_default = /*#__PURE__*/__webpack_require__.n(AddToCalendar);
;// CONCATENATED MODULE: ./components/layout/events/event.tsx





















var ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "fill",
        className: "object-cover w-full h-full"
    });
};
function Figure(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 1960;
    var adjustedHeight = 384 * 2;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        className: "relative w-full h-full",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}
function Layout(param) {
    var preview = param.preview, siteNav = param.siteNav, topNav = param.topNav, topFooterNav = param.topFooterNav, bottomFooterNav = param.bottomFooterNav, siteSettings = param.siteSettings, asPath = param.asPath, contentComponents = param.contentComponents, view = param.view, event = param.event;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var tagList;
    if ((event === null || event === void 0 ? void 0 : event.tags) && event.tags.length >= 1) {
        tagList = event.tags.map(function(tag) {
            return tag.title;
        }).join(",");
    } else {
        tagList = null;
    }
    var siteName = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.title) || null;
    var shareTitle = (event === null || event === void 0 ? void 0 : event.title) || null;
    var shareSummary = (event === null || event === void 0 ? void 0 : event.summary) || null;
    var twitterUsername = ((ref1 = siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.socialLinks) === null || ref === void 0 ? void 0 : ref.find(function(account) {
        return (account === null || account === void 0 ? void 0 : account.socialType) === "twitter";
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.siteLink) === null || ref2 === void 0 ? void 0 : ref2.replace("https://twitter.com/", "")) || null;
    var url = "".concat("https://www.project-graphene.com", "/events/").concat(event.slug);
    var shareImage;
    if (event === null || event === void 0 ? void 0 : (ref3 = event.seoSettings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.openGraphImage) === null || ref4 === void 0 ? void 0 : ref4.asset) {
        var ref33, ref34;
        shareImage = (0,sanity/* urlFor */.uH)(event === null || event === void 0 ? void 0 : (ref33 = event.seoSettings) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.openGraphImage) === null || ref34 === void 0 ? void 0 : ref34.asset).auto("format").width(1200).height(630).url();
    } else if (event === null || event === void 0 ? void 0 : (ref5 = event.mainImage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.image) === null || ref6 === void 0 ? void 0 : ref6.asset) {
        var ref35, ref36;
        shareImage = (0,sanity/* urlFor */.uH)(event === null || event === void 0 ? void 0 : (ref35 = event.mainImage) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.image) === null || ref36 === void 0 ? void 0 : ref36.asset).auto("format").width(1200).height(630).url();
    } else {
        shareImage = null;
    }
    var physicalLocation = "".concat(event === null || event === void 0 ? void 0 : (ref7 = event.location) === null || ref7 === void 0 ? void 0 : ref7.organization, " ").concat(event === null || event === void 0 ? void 0 : (ref8 = event.location) === null || ref8 === void 0 ? void 0 : ref8.address, " ").concat(event === null || event === void 0 ? void 0 : (ref9 = event.location) === null || ref9 === void 0 ? void 0 : ref9.city, " ").concat(event === null || event === void 0 ? void 0 : (ref10 = event.location) === null || ref10 === void 0 ? void 0 : ref10.state, " ").concat(event === null || event === void 0 ? void 0 : (ref11 = event.location) === null || ref11 === void 0 ? void 0 : ref11.zip);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            preview && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(preview_alert/* PreviewAlert */.n, {
                asPath: asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* Header */.h, {
                siteNav: siteNav,
                topNav: topNav,
                siteSettings: siteSettings
            }),
            !(event === null || event === void 0 ? void 0 : event.hideMainImage) && (event === null || event === void 0 ? void 0 : (ref12 = event.mainImage) === null || ref12 === void 0 ? void 0 : ref12.image) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "relative w-full overflow-hidden h-96",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Figure, (0,_object_spread/* default */.Z)({}, event.mainImage))
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: " inner-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "mt-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                className: "block mb-2 text-sm font-medium tracking-widest text-gray-500 uppercase",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                    url: "/events/category/".concat(event === null || event === void 0 ? void 0 : (ref13 = event.category) === null || ref13 === void 0 ? void 0 : ref13.slug),
                                    classes: "hover:underline",
                                    children: event === null || event === void 0 ? void 0 : (ref14 = event.category) === null || ref14 === void 0 ? void 0 : ref14.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative flex mb-8 prose 2xl:-ml-8 md:prose-lg lg:prose-xl prose-h1:mb-0 md:prose-h1:mb-0 lg:prose-h1:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                                        className: "relative order-2",
                                        children: event.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: "/events",
                                        "aria-label": "Back to the main events page.",
                                        classes: "inline-block pr-3 py-3 transition-all opacity-50 hover:opacity-100 order-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiArrowNarrowLeft */.siY, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "flex flex-col justify-between max-w-2xl md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "flex flex-col order-2 mb-8 space-y-8 md:space-x-10 md:space-y-0 md:flex-row md:order-1",
                                        children: [
                                            (event === null || event === void 0 ? void 0 : (ref15 = event.startDate) === null || ref15 === void 0 ? void 0 : ref15.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventDateTime, {
                                                dateTime: event === null || event === void 0 ? void 0 : (ref16 = event.startDate) === null || ref16 === void 0 ? void 0 : ref16.utc,
                                                title: "Starts at"
                                            }),
                                            (event === null || event === void 0 ? void 0 : (ref17 = event.endDate) === null || ref17 === void 0 ? void 0 : ref17.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventDateTime, {
                                                dateTime: event === null || event === void 0 ? void 0 : (ref18 = event.endDate) === null || ref18 === void 0 ? void 0 : ref18.utc,
                                                title: "Ends at"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "order-1 mb-8 md:order-2",
                                        children: (event === null || event === void 0 ? void 0 : event.access) === "links" && (event === null || event === void 0 ? void 0 : (ref19 = event.accessLinks) === null || ref19 === void 0 ? void 0 : ref19.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventAccessLink, {
                                            links: event === null || event === void 0 ? void 0 : event.accessLinks
                                        })
                                    })
                                ]
                            }),
                            !(0,isBefore/* default */.Z)(new Date(), new Date((0,parseISO/* default */.Z)(event === null || event === void 0 ? void 0 : (ref20 = event.startDate) === null || ref20 === void 0 ? void 0 : ref20.utc))) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                className: "md:ml-auto inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-red-600 text-white space-x-2 flex uppercase mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExclamationIcon/* default */.Z, {
                                        className: "w-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        children: "Past Event"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "grid-cols-1 lg:grid md:gap-6 lg:grid-flow-col-dense lg:grid-cols-4 lg:gap-x-12 lg:gap-y-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("aside", {
                                className: "top-0 lg:max-h-screen lg:sticky lg:col-start-4 lg:col-span-1 md:mt-",
                                children: [
                                    (event === null || event === void 0 ? void 0 : (ref21 = event.startDate) === null || ref21 === void 0 ? void 0 : ref21.utc) && (event === null || event === void 0 ? void 0 : (ref22 = event.endDate) === null || ref22 === void 0 ? void 0 : ref22.utc) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((AddToCalendar_default()), {
                                        event: {
                                            name: event === null || event === void 0 ? void 0 : event.title,
                                            details: event === null || event === void 0 ? void 0 : event.summary,
                                            location: physicalLocation,
                                            startsAt: event === null || event === void 0 ? void 0 : (ref23 = event.startDate) === null || ref23 === void 0 ? void 0 : ref23.utc,
                                            endsAt: event === null || event === void 0 ? void 0 : (ref24 = event.endDate) === null || ref24 === void 0 ? void 0 : ref24.utc
                                        }
                                    }),
                                    ((event === null || event === void 0 ? void 0 : event.type) === "inPerson" || (event === null || event === void 0 ? void 0 : event.type) === "both" || (event === null || event === void 0 ? void 0 : event.type) === "virtual") && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "flex flex-col mb-8 space-y-8 md:space-x-10 md:space-y-0 lg:space-y-8 lg:space-x-0 md:flex-row lg:flex-col",
                                        children: [
                                            ((event === null || event === void 0 ? void 0 : event.type) === "inPerson" && (event === null || event === void 0 ? void 0 : event.location) || (event === null || event === void 0 ? void 0 : event.type) === "both" || (event === null || event === void 0 ? void 0 : event.type) === "inPerson") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventLocation, {
                                                location: event === null || event === void 0 ? void 0 : event.location
                                            }),
                                            ((event === null || event === void 0 ? void 0 : event.type) === "both" || (event === null || event === void 0 ? void 0 : event.type) === "virtual") && (event === null || event === void 0 ? void 0 : event.virtualLinks) && (event === null || event === void 0 ? void 0 : event.virtualLinks.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventVirtualLink, {
                                                links: event === null || event === void 0 ? void 0 : event.virtualLinks
                                            })
                                        ]
                                    }),
                                    ((event === null || event === void 0 ? void 0 : event.access) === "links" || (event === null || event === void 0 ? void 0 : event.access) === "tickets") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "flex flex-col mb-10 space-y-8 md:space-x-10 md:space-y-0 lg:space-y-8 lg:space-x-0 md:flex-row lg:flex-col",
                                        children: (event === null || event === void 0 ? void 0 : event.access) === "tickets" && (event === null || event === void 0 ? void 0 : (ref25 = event.products) === null || ref25 === void 0 ? void 0 : ref25.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EventAccessTicket, {
                                            products: event === null || event === void 0 ? void 0 : event.products,
                                            image: (0,sanity/* urlFor */.uH)(event === null || event === void 0 ? void 0 : (ref26 = event.mainImage) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.image) === null || ref27 === void 0 ? void 0 : ref27.asset).auto("format").width(100).height(100).url(),
                                            url: "".concat("https://www.project-graphene.com", "/events/").concat(event.slug)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "relative lg:col-start-1 lg:col-span-3",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "-mb-8 -ml-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_components/* ContentComponents */.W, {
                                        contentComponents: contentComponents,
                                        view: view,
                                        layout: true
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "w-full mb-0 inner-wrapper",
                children: [
                    (event === null || event === void 0 ? void 0 : event.tags) && (event === null || event === void 0 ? void 0 : event.tags.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex flex-wrap items-baseline mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                            className: "flex flex-wrap items-center justify-starts",
                            children: event === null || event === void 0 ? void 0 : (ref28 = event.tags) === null || ref28 === void 0 ? void 0 : ref28.map(function(tag, i) {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                                        url: "/events/tag/".concat(tag.slug),
                                        classes: "transition-all hover:transition-all text-xs mr-3 py-1.5 px-3 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 hover:text-gray-800",
                                        children: [
                                            " #",
                                            tag.slug,
                                            " "
                                        ]
                                    })
                                }, tag._id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(social_share/* SocialShare */.D, {
                        siteName: siteName,
                        shareTitle: shareTitle,
                        shareSummary: shareSummary,
                        shareImage: shareImage,
                        tagList: tagList,
                        twitterUsername: twitterUsername,
                        url: url,
                        updatedAt: event === null || event === void 0 ? void 0 : event.updatedAt
                    })
                ]
            }),
            ((event === null || event === void 0 ? void 0 : event.nextEvent) || (event === null || event === void 0 ? void 0 : event.previousEvent)) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "w-full mb-12 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-row flex-wrap items-center justify-between w-full md:space-y-0",
                    children: [
                        (event === null || event === void 0 ? void 0 : event.previousEvent) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                            url: "/events/".concat(event === null || event === void 0 ? void 0 : (ref29 = event.previousEvent) === null || ref29 === void 0 ? void 0 : ref29.slug),
                            classes: "flex flex-col md:items-center md:flex-row max-w-[40%] transition-all group hover:text-gray-900 space-x-reverse space-x-4 space-y-reverse space-y-2 md:space-y-0 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "order-2 block text-sm text-gray-600 truncate group-hover:text-gray-900",
                                    children: event === null || event === void 0 ? void 0 : (ref30 = event.previousEvent) === null || ref30 === void 0 ? void 0 : ref30.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                    className: "flex items-center order-1 text-xs text-gray-700 group-hover:text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "order-2 font-semibold",
                                            children: " previous event"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "relative order-1 text-2xl group-hover:text-indigo-600",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiChevronLeft */.DEl, {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        (event === null || event === void 0 ? void 0 : event.nextEvent) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                            url: "/events/".concat(event === null || event === void 0 ? void 0 : (ref31 = event.nextEvent) === null || ref31 === void 0 ? void 0 : ref31.slug),
                            classes: "flex flex-col md:space-x-6 space-y-2 space-x-reverse space-y-reverse md:space-x-6 md:text-right md:items-center md:flex-row md:space-y-0 max-w-[40%] transition-all group hover:text-gray-900 ml-auto text-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "order-2 block text-sm text-gray-600 truncate md:order-1 group-hover:text-gray-900",
                                    children: event === null || event === void 0 ? void 0 : (ref32 = event.nextEvent) === null || ref32 === void 0 ? void 0 : ref32.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                    className: "flex items-center justify-end order-1 text-xs text-gray-700 md:order-2 group-hover:text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "order-1 font-semibold",
                                            children: " next event"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "relative order-2 text-2xl group-hover:text-indigo-600",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiChevronRight */.MOd, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(footer/* Footer */.$, {
                siteSettings: siteSettings,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/seo/index.js
var seo = __webpack_require__(3304);
// EXTERNAL MODULE: ./components/shared/loader/index.tsx
var loader = __webpack_require__(8668);
;// CONCATENATED MODULE: ./pages/events/[slug].js








/**
 * Helper function to return the correct version of the document
 * If we're in preview mode, it'll return the preview document
 */ function filterDataToSingleItem(data, preview) {
    if (!Array.isArray(data)) {
        return data;
    }
    if (data.length === 1) {
        return data[0];
    }
    if (preview) {
        return data.find(function(item) {
            return item._id.startsWith("drafts.");
        }) || data[0];
    }
    return data[0];
}
var __N_SSG = true;
/**
 * The `usePreviewSubscription` takes care of updating
 * the preview content on the client-side
 */ function Page(param) {
    var data = param.data, preview = param.preview;
    var ref;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref1;
    var ref2 = (0,sanity/* usePreviewSubscription */.$r)(data === null || data === void 0 ? void 0 : data.query, {
        params: (ref1 = data === null || data === void 0 ? void 0 : data.queryParams) !== null && ref1 !== void 0 ? ref1 : {},
        // The hook needs to know what we started with, to return it immediately
        // This is what it's important to fetch draft content server-side!
        initialData: data === null || data === void 0 ? void 0 : data.page,
        // The passed-down preview context determines whether this function does anything
        enabled: preview
    }), previewData = ref2.data;
    var page = filterDataToSingleItem(previewData, preview);
    // Notice the optional?.chaining conditionals wrapping every piece of content. This is extremely important as you can't ever rely on a single field of data existing when Editors are creating new documents. It'll be completely blank when they start!
    var superPage = (page === null || page === void 0 ? void 0 : page.superPages[0]) || null;
    var siteSettings = (page === null || page === void 0 ? void 0 : page.siteSettings) || null;
    var siteNav = (page === null || page === void 0 ? void 0 : page.siteNav) || null;
    var topNav = (page === null || page === void 0 ? void 0 : page.topNav) || null;
    var topFooterNav = (page === null || page === void 0 ? void 0 : page.topFooterNav) || null;
    var bottomFooterNav = (page === null || page === void 0 ? void 0 : page.bottomFooterNav) || null;
    var contentComponents = ((ref = page === null || page === void 0 ? void 0 : page.superPages[0]) === null || ref === void 0 ? void 0 : ref.contentComponents) || null;
    var router = (0,next_router.useRouter)();
    if (!router.isFallback && !(superPage === null || superPage === void 0 ? void 0 : superPage.slug)) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(error["default"], {
            statusCode: 404
        });
    }
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(loader/* Loader */.a, {});
    }
    // console.log(asPath)
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(seo/* SEO */.H, {
                page: superPage,
                site: siteSettings,
                path: asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Layout, {
                preview: preview,
                asPath: asPath,
                siteNav: siteNav,
                topNav: topNav,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav,
                siteSettings: siteSettings,
                contentComponents: contentComponents,
                event: superPage
            })
        ]
    });
}


/***/ }),

/***/ 2918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6914,6556,5445,7505,3090,8348,8857,9774,2888,179], function() { return __webpack_exec__(7453); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);